import styled from "styled-components";

export const ContentContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column" as const,
    marginTop: theme.spacing.small,
}));

export const WidgetCard = styled.div(({ theme }) => ({
    margin: `${theme.spacing.xLarge} ${theme.spacing.medium}`,
}));

export const Footer = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
    position: "fixed" as const,
    bottom: theme.spacing.empty,
    left: theme.spacing.empty,
    right: theme.spacing.empty,
    padding: theme.spacing.medium,
    boxShadow: theme.elevation[theme.colorMode].liftedNegative.boxShadow,
    "@supports (padding-bottom: var(--sab))": {
        paddingBottom: `calc(${theme.spacing.medium} + var(--sab, 0px))`,
    },
}));
